import { Component, Input } from '@angular/core';
import { ExampleTrendsPreview } from './example-workday.model';

export type ExamplePtTabKey =
  | 'overview'
  | 'trends'
  | 'attention_signals'
  | 'teams'
  | 'employees'
  | 'deep_work'
  | 'communication'
  | 'workload_burnout'
  | 'advanced_patterns';

@Component({
  selector: 'app-example-productivity-trends-preview',
  templateUrl: './example-productivity-trends-preview.component.html',
  styleUrls: [
    '../Admin/reports/productivity-trends/productivity-trends.component.css',
    './example-productivity-trends-preview.component.css',
  ],
  standalone: false,
})
export class ExampleProductivityTrendsPreviewComponent {
  @Input({ required: true }) trends!: ExampleTrendsPreview;

  activeTab: ExamplePtTabKey = 'overview';
  drawerOpen = false;

  readonly tabs: Array<{ key: ExamplePtTabKey; label: string; locked: boolean }> = [
    { key: 'overview', label: 'Overview', locked: false },
    { key: 'trends', label: 'Trends', locked: true },
    { key: 'attention_signals', label: 'Attention Signals', locked: false },
    { key: 'teams', label: 'Teams', locked: true },
    { key: 'employees', label: 'Employees', locked: true },
    { key: 'deep_work', label: 'Deep Work', locked: false },
    { key: 'communication', label: 'Communication', locked: true },
    { key: 'workload_burnout', label: 'Workload & Burnout', locked: true },
    { key: 'advanced_patterns', label: 'Advanced Patterns', locked: true },
  ];

  selectTab(key: ExamplePtTabKey, locked: boolean): void {
    if (locked) {
      return;
    }
    this.activeTab = key;
    this.drawerOpen = false;
  }

  openDrawer(): void {
    this.drawerOpen = true;
  }

  closeDrawer(): void {
    this.drawerOpen = false;
  }

  goAttention(): void {
    this.selectTab('attention_signals', false);
  }

  goDeepWork(): void {
    this.selectTab('deep_work', false);
  }
}
